/**
 * Return the portfolio list context
 *
 * @param  {Object} state
 * @return {Object}
 */
const portfolios = state => {
    return {
        data: state.data,
        meta: state.meta
    }
}

/**
 * Determine if the portfolio list is empty
 *
 * @param  {Object} state
 * @return {Boolean}
 */
const hasPortfolios = state => state.data.length > 0

/**
 * Return the portfolio project list context
 *
 * @param  {Object} state
 * @return {Object}
 */
const portfolioProjects = state => {
    return {
        data: state.projects.data,
        meta: state.projects.meta
    }
}

/**
 * Determine whether the portfolio form has selected projects
 *
 * @return {Boolean} [description]
 */
const hasSelectedProjects = state => state.form.selectedProjects.length > 0

/**
 * Return the list of selected Project IDs for the form
 *
 * @param  {Object} state
 * @return {Array}
 */
const selectedProjects = state => state.form.selectedProjects

/**
 * Get the selected project ID list
 *
 * @param  {Object} state
 * @return {Array}
 */
const selectedProjectIds = state => state.form.selectedProjects.map(project => project.id)

export default {
    portfolios,
    hasPortfolios,
    selectedProjects,
    portfolioProjects,
    selectedProjectIds,
    hasSelectedProjects
}



// WEBPACK FOOTER //
// ./src/state/modules/portfolios/getters.js